export default "/assets/website/images/2star.png?c14c6b9ead01a4530979b4da01418b80";